import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';
import {
  mutationOptions,
  withError,
  withInvalidate,
} from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

export enum SSRFMode {
  Off = 0,
  Audit = 1,
  Enforce = 2,
}

export const AllowListSSRFKey = 0;

export interface AllowList {
  Id: number;
  Mode: SSRFMode;
  Entries: string[];
}

async function getAllowList(): Promise<AllowList> {
  try {
    const { data } = await axios.get<AllowList>(
      `/allowlist/${AllowListSSRFKey}`
    );
    return data;
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to retrieve URL allow list');
  }
}

async function updateAllowList(allowList: AllowList): Promise<AllowList> {
  try {
    const { data } = await axios.put<AllowList>(
      `/allowlist/${AllowListSSRFKey}`,
      allowList
    );
    return data;
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to update URL allow list');
  }
}

export function useAllowList() {
  return useQuery(queryKeys.allowlist(), getAllowList, {
    ...withError('Unable to retrieve URL allow list'),
  });
}

export function useUpdateAllowListMutation() {
  const queryClient = useQueryClient();

  return useMutation(
    updateAllowList,
    mutationOptions(
      withInvalidate(queryClient, [queryKeys.allowlist()]),
      withError('Unable to update URL allow list')
    )
  );
}
